export default {
  data() {
    return {
      // 每个页面需在 data 里设置唯一 sessionKey
      sessionKey: '',
      // 可选：自定义fetch方法名，优先级高于自动推断
      filterFetchMethod: ''
    }
  },
  created() {
    this.restoreFilters()
  },
  watch: {
    searchQuery: {
      handler: 'saveFilters',
      deep: true
    },
    pageNum: 'saveFilters',
    pageSize: 'saveFilters',
    // 额外字段如 orderStatusPaid，页面可自行 watch 并调用 saveFilters
  },
  methods: {
    saveFilters() {
      if (!this.sessionKey) return
      // 支持可选字段扩展
      const data = {
        searchQuery: this.searchQuery,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      // 自动保存常见额外字段
      if (typeof this.orderStatusPaid !== 'undefined') data.orderStatusPaid = this.orderStatusPaid
      sessionStorage.setItem(this.sessionKey, JSON.stringify(data))
    },
    restoreFilters() {
      if (!this.sessionKey) return
      const data = sessionStorage.getItem(this.sessionKey)
      if (data) {
        try {
          const obj = JSON.parse(data)
          if (obj.searchQuery) this.searchQuery = obj.searchQuery
          if (obj.pageNum) this.pageNum = obj.pageNum
          if (obj.pageSize) this.pageSize = obj.pageSize
          if (typeof obj.orderStatusPaid !== 'undefined') this.orderStatusPaid = obj.orderStatusPaid
        } catch (e) {}
      }
      // 自动调用fetch方法
      let fetchMethod = this.filterFetchMethod
      if (!fetchMethod) {
        // 自动推断
        if (typeof this.fetchActivities === 'function') fetchMethod = 'fetchActivities'
        else if (typeof this.fetchParticipants === 'function') fetchMethod = 'fetchParticipants'
        else if (typeof this.fetchOrders === 'function') fetchMethod = 'fetchOrders'
        else if (typeof this.fetchShops === 'function') fetchMethod = 'fetchShops'
      }
      if (fetchMethod && typeof this[fetchMethod] === 'function') {
        this[fetchMethod]()
      }
    }
  }
}
